module.exports = __webpack_public_path__ + "static/media/Snowboarder.d090c7f5.jpg";